import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';

class AiScreenerCandidateResult extends DomainObject {
  explanation;
  rating;

  constructor(other) {
    super();

    makeObservable(this, {
      explanation: observable,
      rating: observable,
      colour: computed,
      ratingDisplay: computed
    });

    this.merge(other);
  }

  get colour() {
    if (this.rating === null) {
      return 'waterloo';
    } else if (this.rating <= 3) {
      return 'scarlet';
    } else if (this.rating <= 6) {
      return 'sun';
    } else if (this.rating <= 10) {
      return 'grass';
    }

    return '';
  }

  get ratingDisplay() {
    if (this.rating === null) {
      return 'Unknown';
    } else {
      return `${this.rating * 10}%`;
    }
  }
}

export default AiScreenerCandidateResult;
